import { CssBaseline, ThemeProvider } from '@mui/material';
import { DostawcaDowodu } from '@/components/SzufladaDowodu';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from 'react-router-dom';
import { router } from '@/app/router';
import { theme } from '@/app/theme';
import { ErrorBoundary } from '@/components/ErrorBoundary';
import { AuthSessionProvider } from '@/lib/auth/AuthContext';
import { ServicesProvider } from '@/lib/ServicesContext';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      // Analityka nie zmienia się co sekundę, a każde zapytanie to realny GROUP BY na bazie
      // operacyjnej. Domyślne agresywne odświeżanie byłoby tu kosztem, nie funkcją.
      staleTime: 60_000,
    },
  },
});

export function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <ErrorBoundary>
        <ServicesProvider>
          <QueryClientProvider client={queryClient}>
            <AuthSessionProvider>
              {/* Szuflada dowodu jest jedna dla całej aplikacji i mieszka NAD routerem: ta sama
                  liczba otwarta z pulpitu i z ekranu sprzedaży musi pokazać to samo wyprowadzenie,
                  a dowód nie może znikać przy zmianie trasy. */}
              <DostawcaDowodu>
                <RouterProvider router={router} />
              </DostawcaDowodu>
            </AuthSessionProvider>
          </QueryClientProvider>
        </ServicesProvider>
      </ErrorBoundary>
    </ThemeProvider>
  );
}
